
import type { PropType } from 'vue'

import { defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import { BidByIdDogovor24 } from '@/core/types/bids.types'

export default defineComponent({
    components: {
        Loader,
        TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        bid: {
            type: [Object, null] as PropType<BidByIdDogovor24 | null>,
            default: null,
        },
        actionsLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update', 'link', 'check', 'delete'],
    setup(props, { emit }) {
        const onUpdate = () => {
            if (props.actionsLoading) return
            emit('update', { ...props.bid })
        }

        const onCheck = () => {
            if (props.actionsLoading) return
            emit('check', { ...props.bid })
        }

        const onDelete = () => {
            if (props.actionsLoading) return
            emit('delete', { ...props.bid })
        }

        return {
            onUpdate,
            onCheck,
            onDelete,
        }
    },
})
